(function () {
	const initProductAccordion = () => {
		$(".product__additional").click(function () {
			const $tab = $(this);
			const $desc = $tab.find(".product__additional-description");
			if ($tab.hasClass("active")) {
				// collapse the open tab
				$tab.removeClass("active");
				$desc.stop(true, true).slideUp(300);
			} else {
				// expand this tab (independent toggle)
				$tab.addClass("active");
				$desc.stop(true, true).slideDown(300);
			}
		});
	};
	
	const initProductSlider = () => {
		document.querySelectorAll(".product-section .product__media-list").forEach((elem) => {
			var slider = new Flickity(elem, {
				pageDots: false,
				prevNextButtons: false,
				adaptiveHeight: true,
				wrapAround: true,
				imagesLoaded: true,
				on: {
					select: function (index) {
						let slides = document.querySelectorAll(".product-section .product__media-list .product__media-item");
	
						var iframe = slides[index]?.querySelector("iframe");
	
						var allIframes = document.querySelectorAll(".product-section .product__media-list iframe");

						var video = slides[index]?.querySelector("video");
						var allVideos = document.querySelectorAll(".product-section .product__media-list video");
	
						if (video && video.length > 0) {
							video.play().catch(error => {
								console.error("Video error:", error);
						});
						} else if (allVideos.length > 0) {
							allVideos.forEach((v) => v.pause());
						}
	
						if (iframe && iframe.length > 0) {
							if (iframe[0].classList.contains('js-youtube')) {
								iframe[0].contentWindow.postMessage(
									JSON.stringify({ event: "command", func: "playVideo" }),
									"*",
								);
							}
							else {
								iframe[0].contentWindow.postMessage('{"method":"play"}', "*");
							}
						} else if (allIframes && allIframes.length > 0) {
							allIframes.forEach(video => {
								if (video.classList.contains('js-youtube')) {
									video.contentWindow.postMessage(
										JSON.stringify({ event: "command", func: "pauseVideo" }),
										"*",
									);
								}
								else {
									video.contentWindow.postMessage('{"method":"pause"}', "*");
								}
							})
						} else {
							return false;
						}
					},
				},
			});

			elem.parentElement.querySelector('.product-section .product__media-list-wrapper-outer-arrow_prev')?.addEventListener( 'click', function() {
				slider.previous();
			});
			elem.parentElement.querySelector('.product-section .product__media-list-wrapper-outer-arrow_next')?.addEventListener( 'click', function() {
				slider.next();
			});
		});

		document.querySelectorAll(".product-section .product__media-sublist").forEach((elem, index) => {
			var mainList = document.querySelectorAll(".product-section .product__media-list")[index];

			// Desktop: vertical static thumbnail rail synced to the main slider.
			if (window.matchMedia("(min-width: 990px)").matches) {
				var mainFlkty = (typeof Flickity !== "undefined") ? Flickity.data(mainList) : null;
				var items = elem.querySelectorAll(".product__media-subitem");
				items.forEach(function (it, i) {
					it.addEventListener("click", function () {
						if (mainFlkty) mainFlkty.select(i);
					});
				});
				if (mainFlkty) {
					var setActive = function () {
						items.forEach(function (it, i) {
							var on = i === mainFlkty.selectedIndex;
							it.classList.toggle("is-nav-selected", on);
							if (on) {
								// Keep the active thumbnail pinned to the top of the rail:
								// forward → rail scrolls up, back → rail scrolls down.
								var railRect = elem.getBoundingClientRect();
								var itRect = it.getBoundingClientRect();
								elem.scrollTo({ top: elem.scrollTop + (itRect.top - railRect.top), behavior: "smooth" });
							}
						});
					};
					mainFlkty.on("select", setActive);
					setActive();
				}

				// Cap the vertical rail to the main image height so extra
				// thumbnails (>5) crop at the bottom and reveal on scroll.
				var outerEl = document.querySelectorAll(".product-section .product__media-list-wrapper-outer")[index];
				var capRail = function () {
					if (!outerEl) return;
					var hh = Math.round(outerEl.getBoundingClientRect().height);
					if (hh <= 0) return;                            // ignore pre-layout 0-height
					elem.style.maxHeight = hh + "px";
					// Scroll room so even the LAST thumbnail can sit at the top of the rail.
					var item = elem.querySelector(".product__media-subitem");
					var itemH = item ? Math.round(item.getBoundingClientRect().height) : 0;
					elem.style.paddingBottom = Math.max(0, hh - itemH) + "px";
				};
				if (outerEl && "ResizeObserver" in window) {
					new ResizeObserver(capRail).observe(outerEl);   // recaps once the image lays out
				}
				capRail();
				window.addEventListener("load", capRail);
				window.addEventListener("resize", capRail);
				return;
			}

			// Mobile: keep the horizontal thumbnail slider.
			new Flickity(elem, {
				asNavFor: mainList,
				contain: true,
				pageDots: false,
				prevNextButtons: false,
				cellAlign: "left",
			});
		});
	}

	document.addEventListener("shopify:section:load", function () {
		if (Shopify.designMode) {
			initProductSlider();
			initProductAccordion();
			initModal("fancy-container-info");
		}
	});

	initProductSlider();
	initModal("fancy-container-info");
	initProductAccordion();
})();
